import { Map } from 'immutable';
import { KEY_DEV } from '@constants/actions';

const initialState = Map({
  keydevList: [],
  totalCount: 0,
  topicRules: [],
  name: 'austin',
  correctionHistory: [],
  indexCurrentVersion: 0,
  keydevTopicList: [],
  publisherList: [],
  keydevRelated: {
    centroidResults: [],
    articleResults: []
  },
  isPendingkeydevCorrection: false,
  updatableStatus: {
    checking: false,
    isCanUpdate: false
  },
  keyDevLogs: [],
  keyDevReport: {
    exportData: {
      data: []
    },
    statsData: {
      metricData: [],
      topicData: []
    }
  }
});

const KeyDev = (state = initialState, action) => {
  const actionPayload = action.payload;
  switch (action.type as keyof typeof KEY_DEV) {
    case KEY_DEV.POPULATE_KEY_DEVS:
      return state
        .set('keydevList', actionPayload.keydevList)
        .set('totalCount', actionPayload.totalCount);

    case KEY_DEV.POPULATE_KEY_DEVS_LOG:
      return state
        .set('keyDevLogs', actionPayload.keydevList)
        .set('totalCount', actionPayload.totalCount);
    case KEY_DEV.POPULATE_KEY_DEVS_REPORT:
      return state.set('keyDevReport', actionPayload.keyDevReport);

    case KEY_DEV.RETRIEVE_KEY_DEV:
      return state.set('selectedKeydev', actionPayload?.keydevDetail);

    case KEY_DEV.RETRIEVE_KEY_DEV_RULE:
      return state.set('topicRules', actionPayload?.topicRules);

    case KEY_DEV.CHANGE_NAME:
      return state.set('name', actionPayload);

    case KEY_DEV.RETRIEVE_KEY_DEV_CORRECTION_HISTORY:
      return state.set('correctionHistory', actionPayload);

    case KEY_DEV.CHANGE_INDEX_CURRENT_VERSION:
      return state.set('indexCurrentVersion', actionPayload);
    case KEY_DEV.POPULATE_KEY_DEV_TOPICS:
      return state.set('keydevTopicList', actionPayload.keydevTopicList);
    case KEY_DEV.POPULATE_PUBLISHERS:
      return state.set('publisherList', actionPayload.publisherList);
    case KEY_DEV.POPULATE_CLUSTER_DETAIL:
      return state.set('clusterDetail', actionPayload.clusterDetail);
    case KEY_DEV.POPULATE_TARGET_CLUSTER:
      return state.set('targetCluster', actionPayload.clusterDetail);

    case KEY_DEV.POPULATE_KEY_DEV_RELATED:
      return state.set('keydevRelated', actionPayload);

    case KEY_DEV.POPULATE_KEY_DEV_UPDATABLE_STATUS:
      return state.set('updatableStatus', actionPayload);

    case KEY_DEV.POPULATE_IS_PENDING_KEY_DEV_CORRECTION:
      return state.set('isPendingkeydevCorrection', actionPayload);
    case KEY_DEV.CLEAR_KEY_DEV_DETAIL:
      return state.set('correctionHistory', [])
        .delete('selectedKeydev');        

    default:
      return state;
  }
};

export default KeyDev;
